// extracted by mini-css-extract-plugin
module.exports = {"btn":"CourseSignUp_btn__a8X10","rr_logo":"CourseSignUp_rr_logo__E3NlT"};